export const DEAL_STATE_GET_REQUEST = 'DEAL_STATE_GET_REQUEST';
export const DEAL_STATE_GET_SUCCESS = 'DEAL_STATE_GET_SUCCESS';
export const DEAL_STATE_GET_ERROR = 'DEAL_STATE_GET_ERROR';
export const DEAL_STATE_GET_BY_KEY_REQUEST = 'DEAL_STATE_GET_BY_KEY_REQUEST';
export const DEAL_STATE_GET_BY_KEY_SUCCESS = 'DEAL_STATE_GET_BY_KEY_SUCCESS';
export const DEAL_STATE_GET_BY_KEY_ERROR = 'DEAL_STATE_GET_BY_KEY_ERROR';
export const DEAL_STATE_ADD_REQUEST = 'DEAL_STATE_ADD_REQUEST';
export const DEAL_STATE_ADD_SUCCESS = 'DEAL_STATE_ADD_SUCCESS';
export const DEAL_STATE_ADD_ERROR = 'DEAL_STATE_ADD_ERROR';
export const DEAL_STATE_EDIT_REQUEST = 'DEAL_STATE_EDIT_REQUEST';
export const DEAL_STATE_EDIT_SUCCESS = 'DEAL_STATE_EDIT_SUCCESS';
export const DEAL_STATE_EDIT_ERROR = 'DEAL_STATE_EDIT_ERROR';
export const DEAL_STATE_DELETE_REQUEST = 'DEAL_STATE_DELETE_REQUEST';
export const DEAL_STATE_DELETE_SUCCESS = 'DEAL_STATE_DELETE_SUCCESS';
export const DEAL_STATE_DELETE_ERROR = 'DEAL_STATE_DELETE_ERROR';
